import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: grid;
  grid-template-columns: 175px 1fr;
  height: calc(100vh - 300px);
  max-height: 600px;
`;

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surface.surface};
  overflow: auto;
`;

export const ErrorBanner = styled.div`
  padding: 12px 24px;
  background-color: ${({ theme }) => theme.colors.danger.dangerContainer};
  color: ${({ theme }) => theme.colors.danger.danger};
  border-bottom: 1px solid ${({ theme }) => theme.colors.danger.danger};
  font-size: 12px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
`;

export const FooterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
`;

export const FooterDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
`;
